import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../../services/api';

function AccountGroupShow() {
    const { id } = useParams();
    const [accountGroup, setAccountGroup] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadAccountGroup();
    }, [id]);

    const loadAccountGroup = async () => {
        try {
            const response = await api.get(`/account_groups/${id}`);
            const group = response.data?.account_group || response.data;
            setAccountGroup(group);
        } catch (error) {
            console.error('Error loading account group:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="p-8 text-center">Loading...</div>;
    if (!accountGroup) return <div className="p-8 text-center">Account group not found</div>;

    return (
        <div className="max-w-4xl mx-auto px-4 py-8">
            <div className="mb-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <Link to="/accounting/account-groups" className="p-2 text-slate-400 hover:text-indigo-600 rounded-lg">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                        </Link>
                        <h1 className="text-2xl font-bold text-slate-800">{accountGroup.name}</h1>
                        {accountGroup.is_active && (
                            <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800">Active</span>
                        )}
                    </div>
                    <Link
                        to={`/accounting/account-groups/${id}/edit`}
                        className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
                    >
                        Edit
                    </Link>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="text-sm font-semibold text-slate-500">Account Head</label>
                        <p className="text-lg text-slate-800 mt-1">
                            {accountGroup.account_head?.name || 'N/A'}
                            {accountGroup.account_head?.account_type && (
                                <span className="text-sm text-slate-500 ml-2">({accountGroup.account_head.account_type})</span>
                            )}
                        </p>
                    </div>

                    <div>
                        <label className="text-sm font-semibold text-slate-500">Opening Balance</label>
                        <p className="text-lg font-semibold text-slate-800 mt-1">
                            ₹{parseFloat(accountGroup.opening_balance || 0).toFixed(2)}
                        </p>
                    </div>

                    {accountGroup.firm_bank_account && (
                        <div>
                            <label className="text-sm font-semibold text-slate-500">Linked Bank Account</label>
                            <p className="text-lg text-slate-800 mt-1">
                                {accountGroup.firm_bank_account.bank_name} - {accountGroup.firm_bank_account.account_number}
                            </p>
                        </div>
                    )}

                    {accountGroup.description && (
                        <div className="md:col-span-2">
                            <label className="text-sm font-semibold text-slate-500">Description</label>
                            <p className="text-slate-700 mt-1">{accountGroup.description}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AccountGroupShow;
